import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Search as SearchIcon } from '@material-ui/icons';
import { matchSorter } from 'match-sorter';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';

//Making this component eligible for receiving ref as a prop from parent components.
//since this is a reusable component.(to be able to set focus using hot key feature from different pages)
const CustomAutoComplete = React.forwardRef((props, ref) => {
	const [open, setOpen] = React.useState(false);
	const loadingState = useSelector((state) => state.autoComplete);
	const loading = props.loading ?? loadingState;
	const filterOptions = (options, { inputValue }) => {
		//only trigger filtering when we have search term and options
		if (options.length > 0 && inputValue.length > 0) {
			const result = matchSorter(options, inputValue, {
				//providing list of fields as filtering keys to enable multi-field filters.
				keys: props.matchSorterKeys,
			});
			return result;
		} else {
			return [];
		}
	};
	//hook use effect which is equivalent to using component life cycles in a state full components
	//Making all options configurable with passing down props from parent component
	React.useEffect(() => {}, [open]);
	return (
		<Autocomplete
			size={props.size}
			id={props.id}
			data-cy={props.id}
			inputValue={props.inputValue}
			label={props.label}
			onInputChange={props.onInputChange}
			onChange={props.onValueChange}
			clearOnBlur={false}
			onKeyDown={props.onKeyDown}
			ref={ref}
			open={open}
			onOpen={() => {
				setOpen(true);
			}}
			onClose={() => {
				setOpen(false);
			}}
			renderOption={(option) => {
				// Render option to enable custom rendering for the parent component.
				if (props.renderOption) {
					return props.renderOption(option);
				} else {
					return option.name;
				}
			}}
			filterOptions={props.filterOptions ?? filterOptions}
			getOptionLabel={props.getOptionsLabel}
			options={props.options}
			loading={loading}
			loadingText={'Loading...'}
			key={'search_customAutocomplete'}
			groupBy={props.groupBy}
			noOptionsText={'No Options'}
			openOnFocus={true}
			renderInput={(
				params, //rendering text field with loading icon and results when making calls to API service
			) => (
				<TextField
					{...params}
					ref={ref}
					placeholder={props.placeHolder}
					variant="outlined"
					InputProps={{
						...params.InputProps,
						startAdornment: props.displayStartAdornment ? props.startAdornment ?? <SearchIcon /> : '',
						endAdornment: (
							<React.Fragment>
								{loading ? <CircularProgress color="inherit" size={20} /> : null}
							</React.Fragment>
						),
					}}
				/>
			)}
		/>
	);
});
export default CustomAutoComplete;
//prop validation for the component
CustomAutoComplete.propTypes = {
	label: propTypes.string,
	onInputChange: propTypes.func,
	onChange: propTypes.func,
	filterOptions: propTypes.func,
	getOptionsLabel: propTypes.func,
	options: propTypes.array,
	placeHolder: propTypes.string,
};
